<div class="app-chat h-100">
  <div class="col-12 container-chat" *ngIf="conversation">
    <div
      class="col-12 chat"
      id="chat"
      [ngClass]="{
        'd-flex align-items-end': conversation
          ? conversation.messages.length == 1
          : false
      }"
    >
      <div
        class="col-12 message-container font-subtitles"
        *ngFor="let message of conversation.messages"
      >
        <div
          class="row col-12 d-flex"
          [ngClass]="{
            'justify-content-start': message.originUser
              ? message.originUser.id !== user.id
              : false,
            'justify-content-end': message.originUser
              ? message.originUser.id === user.id
              : false
          }"
        >
          <div
            class="avatar-div"
            *ngIf="
              message.originUser ? message.originUser.id !== user.id : false
            "
          >
            <div
              class="avatar-chat-2"
              [ngStyle]="{
                background: '#3b9bff url(' + memberSelected.photo + ')',
                'background-repeat': 'no-repeat',
                'background-size': 'cover'
              }"
            ></div>
            <span
              class="hour-message-chat"
              matTooltip="{{ message.created_at | date: 'MM/dd/yyyy':'OOOO' }}"
              >{{ message.created_at | date: 'h:mm a':'OOOO' }}</span
            >
          </div>
          <div
            class="message-div"
            *ngIf="
              message.originUser ? message.originUser.id !== user.id : false
            "
          >
            <div class="col-12 text-message blue-message">
              <span [innerHTML]="message.message | linkify "></span>
            </div>
          </div>
          <div
            class="message-div-2"
            *ngIf="
              message.originUser ? message.originUser.id === user.id : false
            "
          >
            <div class="col-12 text-message-2">
              <span [innerHTML]="message.message | linkify "></span>
            </div>
          </div>
          <div
            class="avatar-div"
            *ngIf="
              message.originUser ? message.originUser.id === user.id : false
            "
          >
            <div
              class="avatar-chat-2"
              [ngStyle]="{
                background:
                  '#3b9bff url(' + (environmentUrl + user.photo) + ')',
                'background-repeat': 'no-repeat',
                'background-size': 'cover'
              }"
            ></div>
            <span
              class="hour-message-chat"
              matTooltip="{{ message.created_at | date: 'MM/dd/yyyy':'OOOO' }}"
              >{{ message.created_at | date: 'h:mm a':'OOOO' }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <hr class="hr" />
    <div class="flex-row m-0 p-0 container">
      <div fxFlex="80" fxFlex.xs="74" class="mr-2">
        <textarea
          required
          rows="3"
          maxlength="250"
          autofocus
          placeholder="Write here your message..."
          [(ngModel)]="message"
          (keyup.enter)="sendMessage()"
          class="custom-input-settings"
        ></textarea>
      </div>

      <div fxFlex="20" fxFlex.xs="26">
        <button
          mat-flat-button
          [disabled]="!message"
          (click)="sendMessage()"
          color="primary"
        >
          Send
        </button>
      </div>
    </div>
  </div>
</div>
